<script>
import ResourceDetail from '@shell/components/ResourceDetail/index.vue';

export default {
  name:       'HarvesterResourcedNamespaceId',
  components: { ResourceDetail },
};
</script>

<template>
  <ResourceDetail />
</template>
